export default __webpack_public_path__ + "static/media/email.c03d3641.svg";